import { render } from "./DateAndTime.vue?vue&type=template&id=7531280a"
import script from "./DateAndTime.vue?vue&type=script&lang=js"
export * from "./DateAndTime.vue?vue&type=script&lang=js"
script.render = render

export default script